import { render } from "./TransporterDashboard.vue?vue&type=template&id=2da6cb4d&scoped=true"
import script from "./TransporterDashboard.vue?vue&type=script&lang=js"
export * from "./TransporterDashboard.vue?vue&type=script&lang=js"

import "./TransporterDashboard.vue?vue&type=style&index=0&id=2da6cb4d&lang=css"
import "./TransporterDashboard.vue?vue&type=style&index=1&id=2da6cb4d&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da6cb4d"]])

export default __exports__